<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-09-21 18:10:36
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-02-08 11:38:03
 * @FilePath: \vue-hepha-order\src\views\stock\StockOutList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <!-- 非ZU用户 -->
        <a-tabs :active-key="activeKey" @change="tabClick" v-if="userInfo.role != '6' && userInfo.role != '7'">
            <a-tab-pane key="1" :title="$t('stock.shipment')"></a-tab-pane>
            <a-tab-pane key="2" :title="$t('stock.return')"></a-tab-pane>
            <a-tab-pane key="3" :title="$t('stock.exchange')"></a-tab-pane>
            <a-tab-pane key="4" :title="$t('stock.reissue')"></a-tab-pane>
            <a-tab-pane key="5" :title="$t('stock.returnFactory')"></a-tab-pane>
        </a-tabs>
        <!-- ZU用户 -->
        <a-tabs :active-key="activeKey" @change="tabClick" v-if="userInfo.role == '6' || userInfo.role == '7'">
            <a-tab-pane key="1" :title="$t('stock.shipment')"></a-tab-pane>
        </a-tabs>

        <OutboundList v-if="activeKey == 1"></OutboundList>
        <ReturnList v-if="activeKey == 2"></ReturnList>
        <SwapList v-if="activeKey == 3"></SwapList>
        <ReissueList v-if="activeKey == 4"></ReissueList>
        <ReturnFactoryList v-if="activeKey == 5"></ReturnFactoryList>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import OutboundList from './OutboundList.vue';
    import ReturnList from './ReturnList.vue';
    import SwapList from './SwapList.vue';
    import ReissueList from './ReissueList.vue';
    import ReturnFactoryList from './ReturnFactoryList.vue';

    const activeKey = ref(1)
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))

    const tabClick = (val)=>{
        console.log(val,'typpppp')
        activeKey.value = val
    }

</script>

<style lang="less" scoped>
/deep/ .arco-tabs-nav-tab{
    background:#fff;
    padding-left: 8px;
}
/deep/ .arco-tabs-content{
    padding-top:6px;
}
</style>